import { useEffect, useCallback } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { optionsChannels } from '../constants/data.constants';
import MockupSMS from '../../../../components/mockups/iphone-sms.component';
import MockupRCS from '../../../../components/mockups/android.component';
import MockupWA from '../../../../components/mockups/iphone.componente';
import ChannelSms from './channels/channel-sms.component';
import ChannelRcs from './channels/channel-rcs.component';
import ChannelWhatsapp from './channels/channel-wa-component';
import Title from '../../../../components/forms/titles.component';
import Radio from '../../../../components/forms/advance-radio-2.component';
import Switch from '../../../../components/forms/switch.component';
import ChannelEmail from './channels/channel-email.component';
import MockupEmail from '../../../../components/mockups/email.component';

function Stepper4({ onValidationChange }: { onValidationChange: (isValid: boolean) => void }) {
  const handleCharacterCountChange = useCallback((count: number) => {
    setValue('totalCaracteresSms', count);
  }, []);

  const { control, register, setValue, watch } = useFormContext();

  const {
    channel: channels,
    masks: mask,
    complementsSwitch: complementsActive,
    complements: complementsSelected,
    phone_number: phoneNumber,
    msgWhatsAppLink: messageWaLink,
    urlLink: link,
    msgSMS: message,
    accountsWa: accountWa,
    templatesWa: templateWa,
    typeRCS: typeRcs,
    agentsRCS: agentsRcs,
    templatesRCS: templateRcs,
    previewTemplateRcs: templatesRcsSelected,
    previewTemplateWa: templatesWaSelected,
    vars: varsWa,
    headersOptions: optionsExamples,
    complements,
    channelfallback: firstFallBack,
    trySecondFallback,
    secondChannelfallback: secondFallBack,
    channelsAvailable,
    accountsEmail: accountsEmail,
    templatesEmail: templatesEmail,
    subjectEmail: subjectEmail,
    varsEmail,
    previewTemplateEmail: templatesEmailSelected
  } = watch();

  const currentChannel = firstFallBack || channels;

  const filteredOptionsChannels = optionsChannels.filter((option: any) => {
    if (option.value === 'wa') return channelsAvailable.includes('whatsapp');
    if (option.value === 'rcs') return channelsAvailable.some((key: any) => key.startsWith('rcs'));
    return channelsAvailable.includes(option.value);
  });

  const stepper4Valid = (() => {
    switch (currentChannel) {
      case 'sms': {
        const baseValidation = !!mask && !!message;
        if (!complementsActive) return baseValidation;
        const isComplementSelected = !!complementsSelected;
        const complementValidators: Record<string, boolean> = {
          WHATSAPP_LINK: !!phoneNumber && !!messageWaLink,
          LINK: !!link
        };
        const isComplementValid = complementValidators[complementsSelected] ?? true;
        return baseValidation && isComplementSelected && isComplementValid;
      }
      case 'rcs':
        return !!typeRcs && !!agentsRcs && !!templateRcs;
      case 'wa':
        return !!accountWa && !!templateWa;
      case 'email':
        return !!accountsEmail && !!templatesEmail && !!subjectEmail;
      default:
        return false;
    }
  })();

  useEffect(() => {
    onValidationChange(true);
  }, [stepper4Valid]);

  useEffect(() => {
    setValue('channelfallback', '');
    setValue('trySecondFallback', false);
    setValue('secondChannelfallback', '');
  }, [channels]);

  useEffect(() => {
    if (firstFallBack === 'sms') {
      setValue('trySecondFallback', false);
      setValue('secondChannelfallback', '');
    }
  }, [firstFallBack]);

  return (
    <>
      <div className="text-left mb-3">
        <Title
          icon="ki-send"
          title={'1° Canal principal de envío'}
          subtitle={'Iniciaremos el envio de tus mensajes por el canal que eligas.'}
          type="info"
        />
      </div>
      <div className="d-flex flex-stack cursor-pointer mb-3">
        <div className="d-flex align-items-center">
          <span className="symbol symbol-label"></span>
          <div className="d-flex flex-column">
            <span className="fw-bolder fs-3 required">Canales</span>
            <span className="fs-6">Elige uno de los disponibles.</span>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <Controller
          control={control}
          name="channel"
          rules={{ required: 'Para poder procesar tu campaña es necesario registrar un canal' }}
          render={({ field, fieldState: { error } }) => {
            const currentValue = field.value;
            const filteredOptions = filteredOptionsChannels.filter(
              (option) => option.type !== 'sms' || option.value === currentValue
            );

            return filteredOptions.length === 0 ? (
              <div className="text-center w-100">
                <img
                  src="/assets/media/illustrations/undraw/no-find.svg"
                  alt="No se encontraron canales"
                  style={{ maxWidth: '300px', margin: '0 auto' }}
                />
                <p className="mt-3 fs-3 text-primary fw-bolder">No tienes canales habilitados.</p>
              </div>
            ) : (
              <Radio
                {...field}
                options={filteredOptionsChannels.filter((option) => option.value !== 'sms')}
                errors={error}
              />
            );
          }}
        />
      </div>
      <div className="row">
        <div className="col-md-7">
          {channels === 'sms' && <ChannelSms />}
          {channels === 'rcs' && <ChannelRcs />}
          {channels === 'wa' && <ChannelWhatsapp />}
          {channels === 'email' && <ChannelEmail />}
        </div>
        <div className="col-md-5 sticky-box">
          <div className="sticky-box">
            {channels === 'sms' && (
              <div className="mb-15">
                <MockupSMS
                  message={message}
                  variables={optionsExamples}
                  shortURL={complements === 'WHATSAPP_LINK' || complements === 'LINK'}
                  onCharacterCountChange={handleCharacterCountChange}
                />
              </div>
            )}
            {channels === 'rcs' && (
              <div className="mb-10 ms-3">
                <MockupRCS
                  payload={templatesRcsSelected}
                  type={templatesRcsSelected?.type ? templatesRcsSelected.type.toLowerCase() : ''}
                  exmplesCampaigns={optionsExamples}
                />
              </div>
            )}
            {channels === 'wa' && (
              <div className="mb-10">
                <MockupWA
                  payload={templatesWaSelected}
                  vars={varsWa}
                  exmplesCampaigns={optionsExamples}
                />
              </div>
            )}
            {channels === 'email' && (
              <MockupEmail
                payload={templatesEmailSelected}
                varsEmail={varsEmail}
                examplesCampaigns={optionsExamples}
                subject={subjectEmail}
              />
            )}
          </div>
        </div>
      </div>
      {channels && (
        <>
          <div className="separator separator-dashed separator-content text-dark mb-15">
            <img alt="Logo" src="/assets/media/logos/logo-c.svg" className="w-30px logo-minimize" />
          </div>
          <div className="text-left mb-3">
            <Title
              icon="ki-send"
              title={'2° Canal de envío del seguno intento'}
              subtitle={
                'Los mensajes que no se entregarón por algún error al iniciar tu campaña, serán reenviados por otro canal, el cual podrás seleccionar en esta sección.'
              }
              type="info"
            />
          </div>
          <div className="d-flex flex-stack cursor-pointer mb-3">
            <div className="d-flex align-items-center">
              <span className="symbol symbol-label"></span>
              <div className="d-flex flex-column">
                <span className="fw-bolder fs-3 required">Canales</span>
                <span className="fs-6">Elige uno de los disponibles.</span>
              </div>
            </div>
          </div>
          <Controller
            control={control}
            name="channelfallback"
            rules={{
              required:
                'Es necesario elegir un canal para tu segundo intento del envío de tus mensajes.'
            }}
            render={({ field, fieldState: { error } }) => {
              const channelMap: Record<string, string> = {
                wa: 'whatsapp'
              };
              const matchesChannel = (availableChannel: string, currentChannel: string) => {
                if (currentChannel === 'rcs') {
                  return availableChannel.startsWith('rcs_');
                }

                if (currentChannel === 'wa') {
                  return availableChannel === 'whatsapp';
                }

                return availableChannel === currentChannel;
              };

              const filteredOptions = optionsChannels.filter((option) => {
                if (option.value === channels) return false;

                const normalized = channelMap[option.value] || option.value;
                return channelsAvailable.some((avCh: any) => matchesChannel(avCh, normalized));
              });

              return filteredOptions.length === 0 ? (
                <div className="text-center w-100">
                  <img
                    src="/assets/media/illustrations/undraw/no-find.svg"
                    alt="No se encontraron canales"
                    style={{ maxWidth: '300px', margin: '0 auto' }}
                  />
                  <p className="mt-3 fs-3 text-primary fw-bolder">No tienes canales habilitados.</p>
                </div>
              ) : (
                <Radio {...field} options={filteredOptions} errors={error} />
              );
            }}
          />

          <div className="row">
            <div className="col-md-7">
              {firstFallBack === 'sms' && <ChannelSms />}
              {firstFallBack === 'rcs' && <ChannelRcs />}
              {firstFallBack === 'wa' && <ChannelWhatsapp />}
              {firstFallBack === 'email' && <ChannelEmail />}
            </div>
            <div className="col-md-5">
              <div className="sticky-box">
                {firstFallBack === 'sms' && (
                  <div className="mb-15">
                    <MockupSMS
                      message={message}
                      variables={optionsExamples}
                      shortURL={complements === 'WHATSAPP_LINK' || complements === 'LINK'}
                      onCharacterCountChange={handleCharacterCountChange}
                    />
                  </div>
                )}
                {firstFallBack === 'rcs' && (
                  <div className="mb-10 ms-3">
                    <MockupRCS
                      payload={templatesRcsSelected}
                      type={
                        templatesRcsSelected?.type ? templatesRcsSelected.type.toLowerCase() : ''
                      }
                      exmplesCampaigns={optionsExamples}
                    />
                  </div>
                )}
                {firstFallBack === 'wa' && (
                  <div className="mb-10">
                    <MockupWA
                      payload={templatesWaSelected}
                      vars={varsWa}
                      exmplesCampaigns={optionsExamples}
                    />
                  </div>
                )}
                {firstFallBack === 'email' && (
                  <MockupEmail
                    payload={templatesEmailSelected}
                    varsEmail={varsEmail}
                    examplesCampaigns={optionsExamples}
                    subject={subjectEmail}
                  />
                )}
              </div>
            </div>
          </div>
          {firstFallBack &&
            (firstFallBack !== 'sms' ? (
              <div className="fv-row mb-1">
                {channelsAvailable.length > 2 && (
                  <div className="d-flex flex-stack cursor-pointer mb-3">
                    <div className="d-flex align-items-center mb-5">
                      <span className="symbol me-e6 symbol-label" />
                      <div className="d-flex flex-column">
                        <span className="fw-bolder fs-3">
                          Tercer intento <span className="fs-7">(opcional)</span>
                        </span>
                        <span className="fs-6">
                          Reintenta enviar los mensajes que no se entregaron por algún error tras un
                          segundo intento.
                        </span>
                      </div>
                    </div>
                    <span className="form-check form-check-custom form-check-solid">
                      <Switch {...register('trySecondFallback')} />
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center text-center p-4">
                <img
                  alt="Sin elementos"
                  title="empty-table"
                  className="mb-5 animated-Alert"
                  src="/assets/media/illustrations/undraw/notify.svg"
                  width="28%"
                />
                <p
                  className="mb-0 fs-6 text-justify"
                  style={{ textAlign: 'justify', maxWidth: '600px' }}
                >
                  <strong className="text-danger">IMPORTANTE:</strong> Si eliges SMS como canal de
                  envío, no podemos ofrecerte otro canal para reenviar los mensajes fallidos (como
                  WhatsApp o RCS). Esto se debe a que el número de teléfono es el identificador
                  principal en todos los canales. Si un mensaje no se entrega por SMS, es probable
                  que tampoco pueda entregarse por otros canales.
                </p>
              </div>
            ))}
        </>
      )}
      {trySecondFallback && (
        <>
          <div className="separator separator-dashed separator-content text-dark mb-15">
            <img alt="Logo" src="/assets/media/logos/logo-c.svg" className="w-30px logo-minimize" />
          </div>
          <div className="text-left mb-3">
            <Title
              icon="ki-send"
              title={'3° Canal de envío del tercer intento'}
              subtitle={
                'Los mensajes que no se entregarón por algún error tras el segundo intento, serán reenviados por otro canal, el cual podrás seleccionar en esta sección.'
              }
              type="info"
            />
          </div>
          <div className="d-flex flex-stack cursor-pointer mb-3">
            <div className="d-flex align-items-center">
              <span className="symbol symbol-label"></span>
              <div className="d-flex flex-column">
                <span className="fw-bolder fs-3 required">Canales</span>
                <span className="fs-6">Elige uno de los disponibles.</span>
              </div>
            </div>
          </div>
          <Controller
            control={control}
            name="secondChannelfallback"
            rules={{
              required: 'Debes elegir un canal para tu tercer intento del envío de tus mensajes.'
            }}
            render={({ field, fieldState: { error } }) => {
              const filteredOptions = optionsChannels.filter(
                (option) => option.value !== firstFallBack && option.value !== channels
              );

              return <Radio {...field} options={filteredOptions} errors={error} />;
            }}
          />
          <div className="row">
            <div className="col-md-7">
              {secondFallBack === 'sms' && <ChannelSms />}
              {secondFallBack === 'rcs' && <ChannelRcs />}
              {secondFallBack === 'wa' && <ChannelWhatsapp />}
              {secondFallBack === 'email' && <ChannelEmail />}
            </div>
            <div className="col-md-5">
              <div className="sticky-box">
                {secondFallBack === 'sms' && (
                  <div className="mb-15">
                    <MockupSMS
                      message={message}
                      variables={optionsExamples}
                      shortURL={complements === 'WHATSAPP_LINK' || complements === 'LINK'}
                      onCharacterCountChange={handleCharacterCountChange}
                    />
                  </div>
                )}
                {secondFallBack === 'rcs' && (
                  <div className="mb-10 ms-3">
                    <MockupRCS
                      payload={templatesRcsSelected}
                      type={
                        templatesRcsSelected?.type ? templatesRcsSelected.type.toLowerCase() : ''
                      }
                      exmplesCampaigns={optionsExamples}
                    />
                  </div>
                )}
                {secondFallBack === 'wa' && (
                  <div className="mb-10">
                    <MockupWA
                      payload={templatesWaSelected}
                      vars={varsWa}
                      exmplesCampaigns={optionsExamples}
                    />
                  </div>
                )}
                {secondFallBack === 'email' && (
                  <MockupEmail
                    payload={templatesEmailSelected}
                    varsEmail={varsEmail}
                    examplesCampaigns={optionsExamples}
                    subject={subjectEmail}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Stepper4;
